import { Stack } from "@mui/material";
import { BlockRenderer } from "@/components/ChatResponseElements";
import SourcesPanel from "@/components/Citations/SourcesPanel";
import IncompleteAnswerNotice from "./IncompleteAnswerNotice";
import UsedMemoryIndicator from "./UsedMemoryIndicator";

export default function Phase1ResponseTail({
  assistant,
  blocks,
  citations,
  streaming,
  animateEnter,
  onAgentQuestionSelect,
}) {
  return (
    <>
      <IncompleteAnswerNotice message={assistant.phase1ErrorMessage} />
      {blocks.length ? (
        <BlockRenderer
          blocks={blocks}
          citations={citations}
          streaming={streaming}
          animateEnter={animateEnter}
          onAgentQuestionSelect={onAgentQuestionSelect}
        />
      ) : null}
      <Stack
        direction="row"
        sx={{ alignItems: "center", gap: 1, flexWrap: "wrap" }}
      >
        <UsedMemoryIndicator memoryIds={assistant.memoryIds ?? []} />
      </Stack>
      <SourcesPanel citations={citations} />
    </>
  );
}
